import { createTabSlice } from '../helpers';

const tabs = [
  {
    label: 'Dicom Conversion',
    icon: 'TheatersIcon',
    component: 'AutomatedJobs/DicomConversion',
    actionBar: null,
  },
  {
    label: 'Sequence Splitting',
    icon: 'CallSplitIcon',
    component: 'AutomatedJobs/SequenceSplitting',
    actionBar: null,
  },
  {
    label: 'Autolabel',
    icon: 'ArtTrackIcon',
    component: 'AutomatedJobs/Autolabel',
    actionBar: null,
  },
  {
    label: 'Preprocessing',
    icon: 'SettingsApplicationsIcon',
    component: 'AutomatedJobs/Preprocessing',
    actionBar: null,
  },
  {
    label: 'Label Check',
    icon: 'SettingsApplicationsIcon',
    component: 'AutomatedJobs/LabelCheck',
    actionBar: null,
  },
];

export const tabSlice = createTabSlice({ name: 'automatedJobs/tabs', tabs });
